import React from "react";
import { RotatingLines as ReactRotatingLines } from "react-loader-spinner";

const RotatingLines = () => {
  return (
    <ReactRotatingLines
      visible={true}
      height="20"
      width="20"
      color="grey"
      strokeColor="#6a18ed"
      strokeWidth="4"
      animationDuration="0.75"
      ariaLabel="rotating-lines-loading"
    />
  );
};

export default RotatingLines;
